<template>
  <el-popover placement="bottom" width="500" trigger="click" :offset="40">
    <el-table-wrapper :data="legendData" :columns="legendTableColumns" :column-default="columnDefault" :max-height="250" :pagination="false"></el-table-wrapper>
    <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
  </el-popover>
</template>

<script>
import { columnDefault } from '@/constants/table';

export default {
  name: 'WScriptKeywordLegend',
  data() {
    return {
      columnDefault,
      legendData: [
        {
          value: '$send$',
          desc: '명령어를 보냅니다.',
        },
        {
          value: '$expect$',
          desc: '특정 문자열이 올 때까지 기다립니다.',
        },
        {
          value: '$user_id$',
          desc: '로그인 이름',
        },
        {
          value: '$password$',
          desc: '패스워드',
        },
        {
          value: '$privilegePassword$',
          desc: 'Enable 패스워드',
        },
        {
          value: '$expectpromt$',
          desc: '저장된 프롬프트가 올 때까지 대기합니다.',
        },
        {
          value: '$usepromt$',
          desc: '로그인 성공 후 프롬프트로 사용합니다.',
        },
        {
          value: '$sendEM$',
          desc: '제어 문자 EM을 보냅니다.',
        },
        {
          value: '$changePwId$',
          desc: '패스워드 변경 아이디',
        },
        {
          value: '$changePw$',
          desc: '변경 패스워드',
        },
        {
          value: '$beforePw$',
          desc: '기존 패스워드',
        },
        {
          value: '$fullpath$',
          desc: '장비 펌웨어 경로',
        },
        {
          value: '$ipaddress$',
          desc: '파일 서버 IP 주소',
        },
        {
          value: '$scpId$',
          desc: 'SCP 아이디',
        },
        {
          value: '$scpPw$',
          desc: 'SCP 패스워드',
        },
        {
          value: '$path$',
          desc: '업데이트 펌웨어 경로',
        },
        {
          value: '$filename$',
          desc: '펌웨어 이미지 파일명',
        },
      ],
      legendTableColumns: [
        {
          prop: 'value',
          label: '예약어',
          sortable: true,
          searchable: false,
        },
        {
          prop: 'desc',
          label: '설명',
          sortable: true,
          searchable: false,
        },
      ],
    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/button/ScriptKeywordLegend.vue